import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "counter"]
  static values = { minimum: { type: Number, default: 50 } }

  connect() {
    this.update()
  }

  update() {
    const length = this.inputTarget.value.trim().length
    this.counterTarget.textContent = length
    const met = length >= this.minimumValue
    this.counterTarget.classList.toggle("text-green-600", met)
    this.counterTarget.classList.toggle("font-semibold", met)
    this.inputTarget.setCustomValidity(
      met || length === 0 ? "" : `Please enter at least ${this.minimumValue} characters (${length} so far).`
    )
  }
}
